import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import { Button } from 'components/UI/'
import infoIcon from '../../../../../../../assetss/img/infoIcon.svg'
import c from 'classnames'
import './index.scss'

const RequestChatMessage = ({ name, text, acceptDeclineChat, noBtn }) => (
  <Grid className={c('requesChatMessage', +noBtn > 1 && 'newHeightMargin')}>
    <Grid className='headerMessage'>
      <img className='iconMessage' src={infoIcon} />
      <Typography className='titleMessage'>You received a new meeting request:</Typography>
    </Grid>
    <Typography className='userName'>{name?.substr(0, 1)}</Typography>
    <Typography className='messageText'>{text}</Typography>
    {+noBtn === 1 && (
      <Grid className='btnContainer'>
        <Button onClick={() => acceptDeclineChat('accept')} className='btnAccept'>Accept</Button>
        <Button onClick={() => acceptDeclineChat('decline')} className='btnDecline'>Decline</Button>
      </Grid>
    )}
  </Grid>
)

export default RequestChatMessage
